<template>
  <div class="okrItem">
    <b-container class="objective objective-text current-obj" @click="setObj(item)" :class="{ selected: (item.itemId == selectedKey) }">
      <b-row>
        <div class="objective-detail">
          <objective :page="'report'" :itemId="item.itemId" :detailView="true" :content="this.item.contentText" :progress="this.item.progress ? '' + this.item.progress : '0'" :setReadOnly="'false'" :objective="false" />
        </div>
      </b-row>
      <div class="text-center small pt-2">
        <label class="mb-0">{{ $t('startDateStr') }}：</label>
        <span>{{item.startDate}}</span>
      </div>
      <div class="d-flex justify-content-between align-items-end">
        <b-btn variant="outline-warning" size="sm" @click="jump(item, 'objective')" class="btn-open-detail">Jump</b-btn>
        <div class="mr-auto text-nowrap">
          <span><i class="fa fa-angle-double-left"></i></span>
          <b-badge pill variant="danger">{{ item.numRelationsDst }}</b-badge>
        </div>
        <div class="text-center small pt-2">
          <label class="mb-0">{{ $t('dueDateStr') }}：</label>
          <span>{{ item.dueDate }}</span>
        </div>
        <div class="ml-auto text-nowrap">
          <span v-if="item.isComplete" class="comp-label">{{$t('secStr')}}</span>
          <b-badge pill variant="danger">{{ item.numRelationsSrc }}</b-badge>
          <span><i class="fa fa-angle-double-left"></i></span>
        </div>
      </div>
    </b-container>
    <hr v-if="item.keyresults" class="m-0">
    <template v-for="(kr, krId) in item.keyresults">
      <b-container class="keyresult" :key="krId" @click="setKr(kr)" :class="{ selected: (krId == selectedKey) }" v-if="isBetweenDate(kr)">
        <b-row>
          <div class="objective-detail">
            <objective :page="'report'" :itemId="krId" :detailView="true" :content="kr.contentText" :progress="kr.progress ? '' + kr.progress : '0'" :setReadOnly="'false'" :objective="false" />
          </div>
        </b-row>
        <div class="text-center small pt-2">
          <label class="mb-0">{{ $t('startDateStr') }}：</label>
          <span>{{kr.startDate}}</span>
        </div>
        <div class="d-flex justify-content-between align-items-end">
          <b-btn variant="outline-warning" size="sm" @click="jump(kr, 'keyresult')" class="btn-open-detail">Jump</b-btn>
          <div class="mr-auto text-nowrap">
            <span><i class="fa fa-angle-double-left"></i></span>
            <b-badge pill variant="danger">{{ kr.numRelationsDst }}</b-badge>
          </div>
          <div class="text-center small pt-2">
            <label class="mb-0">{{ $t('dueDateStr') }}：</label>
            <span>{{ kr.dueDate }}</span>
          </div>
          <div class="ml-auto text-nowrap">
            <span v-if="kr.isComplete" class="comp-label">{{$t('secStr')}}</span>
            <b-badge pill variant="danger">{{ kr.numRelationsSrc }}</b-badge>
            <span><i class="fa fa-angle-double-left"></i></span>
          </div>
        </div>
      </b-container>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Objective from '@/components/Okr/Objective'
import ObjectiveKnob from '@/components/Okr/ObjectiveKnob'

export default {
  name: 'ReportRelationsListOkrItem',
  components: {
    // moment,
    Objective,
    ObjectiveKnob
  },
  props: ['item', 'selectedKey', 'fromDate', 'toDate', 'searchType'],
  data: function () {
    return {
      scrolling: false
    }
  },
  getters: {
  },
  computed: {
    ...mapGetters([
      // 'getKeyresultsByUser'
    ]),
    ...mapGetters('keyResults/', [
      'getKeyresults'
    ])
  },
  created: function () {
  },
  updated: function () {
    // this.scrollToSelected()
  },
  mounted: function () {
  },
  methods: {
    setObj (val) {
      console.log('setObj: ', val)
      this.$emit('set-item', val)
    },
    setKr (val) {
      console.log('setKr: ', val)
      this.$emit('set-item', val)
    },
    jump: function (value, itemType) {
      console.log(' this.$emit(get-detail)', value, itemType)
      if (itemType) {
        itemType = itemType.replace(/^(objective|keyresult)$/, '$1s')
        value.type = {}
        value.type[itemType] = value.itemId || ''
      }
      this.$emit('open-detail', value)
    },
    scrollToSelected: function () {
      const selectedItem = document.getElementsByClassName('container selected')[0]
      console.log('scrollToSelected', selectedItem)

      let options = {
        container: 'body',
        easing: 'ease-in',
        offset: 0,
        cancelable: true,
        onStart: function (element) {
          console.log('// scrolling started')
        },
        onDone: function (element) {
          console.log('// scrolling is done')
        },
        onCancel: function () {
          console.log('// scrolling has been interrupted')
        },
        x: false,
        y: true
      }
      let duration = 200
      const scrollToSelectedItem = this.$scrollTo(selectedItem, duration, options)
      scrollToSelectedItem()
    },
    isBetweenDate (item) {
      if (!item || !Object.keys(item).length) { return false }
      let dueDate = moment(item.dueDate || 0).format('YYYYMMDD')
      let startDate = item.startDate ? moment(item.startDate || 0).format('YYYYMMDD') : moment(item.dueDate || 0).format('YYYYMMDD')
      let fromDate = moment(this.fromDate).format('YYYYMMDD')
      let toDate = moment(this.toDate).format('YYYYMMDD')
      switch (this.searchType) {
        case 'dueDate':
          return (this.fromDate ? dueDate >= fromDate : true) && (this.toDate ? dueDate <= toDate : true)
        case 'startDate':
          return (this.fromDate ? startDate >= fromDate : true) && (this.toDate ? startDate <= toDate : true)
        case 'active':
          return (this.fromDate ? dueDate >= fromDate : true) && (this.toDate ? startDate <= toDate : true)
        default:
          return false
      }
    }
  },
  filters: {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
a:hover{
  text-decoration: none;
}
.okrItem {
  transition: .2s;
  // font-size: 75%;
  .keyresult.container {
    margin: 1em auto;
  }
  .container {
    padding: 0;
    // margin: 1em auto;
    cursor: pointer;
    transition: .2s;
    position: relative;
    .btn-open-detail {
      display: none;
      position: absolute;
      // top: 24px;
      // right: 1.2em;
      bottom: 1.5em;
      z-index: 999;
    }
    &:hover {
      transition: .2s;
      .btn-open-detail {
        display: block;
        &:not(:hover) {
          background-color: rgba(255,255,255,.7)
        }
      }
    }
  }
  .objective {
    display: block;
    box-shadow: 0 0 .1em .3em transparent;
    &:hover {
      box-shadow: 0 0 .1em .3em #333399;
    }
  }
  .keyresult {
    padding-left: 1em;
    padding-bottom: 0.5em;
    box-shadow: 0 0 .1em .3em transparent;
    &:hover {
      box-shadow: 0 0 .1em .3em #6666ff;
    }
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .btn-open-detail {
      bottom: 2.1em;
    }
  }
  .selected {
    box-shadow: 0 0 .1em .3em #ccccFF;
    box-shadow: 0 0 .1em .3em transparent;
  }
  .objective-text {
    margin-left: 0;
    .content-text {
      margin-bottom: 0;
    }
  }
  .content-text {
    padding-left: .25em;
    padding-right: .25em;
    background: transparent;
    font-size: 90%;
  }
  .item-bottom {
    margin-top: 0.5em;
    border-top: 1px dotted rgba(0, 0, 0, 0.1);
  }
  .objective-detail{
    margin: 0 15px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportRelationsListOkrItem.vue